(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function() {
    var WISHLIST_KEY = 'zlt_wishlist';

    function getWishlist() {
      try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch(e) { return []; }
    }

    function saveWishlist(list) {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    }

    function isWishlisted(id) {
      return getWishlist().some(function(p) { return p.id == id; });
    }

    function updateAllBtns(id, state) {
      document.querySelectorAll('.zlt-wishlist-btn[data-product-id="' + id + '"]').forEach(function(btn) {
        btn.classList.toggle('is-wishlisted', state);
      });
    }

    function initBtns() {
      document.querySelectorAll('.zlt-wishlist-btn').forEach(function(btn) {
        var id = btn.dataset.productId;
        if (isWishlisted(id)) btn.classList.add('is-wishlisted');
      });
    }

    function showToast(msg) {
      var existing = document.querySelector('.zlt-wishlist-toast');
      if (existing) existing.remove();
      var toast = document.createElement('div');
      toast.className = 'zlt-wishlist-toast';
      toast.textContent = msg;
      document.body.appendChild(toast);
      requestAnimationFrame(function() {
        requestAnimationFrame(function() { toast.classList.add('is-visible'); });
      });
      setTimeout(function() {
        toast.classList.remove('is-visible');
        setTimeout(function() { toast.remove(); }, 300);
      }, 2200);
    }

    function popHeart(btn) {
      btn.classList.remove('is-popping');
      void btn.offsetWidth;
      btn.classList.add('is-popping');
      setTimeout(function() { btn.classList.remove('is-popping'); }, 500);
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.zlt-wishlist-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var id = btn.dataset.productId;
      var list = getWishlist();
      var found = false;
      for (var i = 0; i < list.length; i++) {
        if (list[i].id == id) { list.splice(i, 1); found = true; break; }
      }
      if (found) {
        updateAllBtns(id, false);
        showToast('Removed from wishlist');
      } else {
        list.push({
          id: id,
          handle: btn.dataset.productHandle,
          title: btn.dataset.productTitle,
          image: btn.dataset.productImage,
          price: btn.dataset.productPrice,
          url: btn.dataset.productUrl,
          variantId: btn.dataset.variantId
        });
        updateAllBtns(id, true);
        showToast('Added to wishlist');
      }
      popHeart(btn);
      saveWishlist(list);
      document.dispatchEvent(new CustomEvent('zlt:wishlist:updated', { detail: { count: list.length } }));
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBtns);
    } else {
      initBtns();
    }
  })();

  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.product-card__color-swatch');
    if (!swatch) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var card = swatch.closest('product-card');
    if (!card) return;
    var variantImage = swatch.dataset.variantImage;
    if (variantImage) {
      var img = card.querySelector('img');
      if (img) {
        img.src = variantImage;
        img.srcset = variantImage;
      }
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
